import angular from 'angular';
import TotalsConfig from './totals.config';
import TotalsComponent from './totals.component';
export default angular.module('index.customercare.customer.totals', []).component('totals', TotalsComponent).config(TotalsConfig).name;